import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false,
});

export function metricsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_METRICS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_METRICS_SUCCESS:
    case actionTypes.GET_METRICS_FAIL:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        metrics: [action.payload] || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
